import { render, staticRenderFns } from "./good-label.vue?vue&type=template&id=4c3acfac&scoped=true&"
import script from "./good-label.vue?vue&type=script&lang=js&"
export * from "./good-label.vue?vue&type=script&lang=js&"
import style0 from "./good-label.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-label.vue?vue&type=style&index=1&id=4c3acfac&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3acfac",
  null
  
)

export default component.exports